import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React, { PureComponent } from 'react';
import types from 'prop-types';
import invariant from 'invariant';
import { styled, StyleSheet } from '@rexlabs/styling';
import TabBarDefault from './tab-bar';
var defaultStyles = StyleSheet({
  container: {
    width: '100%'
  },
  tabHidden: {
    display: 'none'
  }
});
var Tabs = (_dec = styled(defaultStyles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  function Tabs() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "prevIndex", null);

    return _this;
  }

  _createClass(Tabs, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.activeTab !== nextProps.activeTab) {
        var _context2;

        this.prevIndex = _findIndexInstanceProperty(_context2 = this.props.items).call(_context2, function (i) {
          return i.name === _this2.props.activeTab;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          items = _this$props.items,
          activeTab = _this$props.activeTab,
          onChange = _this$props.onChange,
          TabBar = _this$props.TabBar,
          s = _this$props.styles,
          alwaysRenderAll = _this$props.alwaysRenderAll,
          rest = _objectWithoutProperties(_this$props, ["children", "items", "activeTab", "onChange", "TabBar", "styles", "alwaysRenderAll"]); // Some invariant validations of props with meaningful error messages


      invariant(activeTab !== undefined, 'You have to define an \'activeTab\' prop on Tabs.\n\n' + 'If you don\'t want to deal with the tab state handling, ' + 'you can use \'TabStateful\' instead!');
      invariant(onChange !== undefined, 'You have to define an \'onChange\' hanlder on Tabs.\n\n' + 'If you don\'t want to deal with the tab state handling, ' + 'you can use \'TabStateful\' instead!');

      _forEachInstanceProperty(items).call(items, function (item) {
        invariant(item.name, 'You have to define a unique name for each tab item!');
      });

      var tabs = _mapInstanceProperty(items).call(items, function (_ref, index) {
        var name = _ref.name,
            _ref$Tab = _ref.Tab,
            Tab = _ref$Tab === void 0 ? function () {
          return null;
        } : _ref$Tab;
        var isActive = name === activeTab || !activeTab && index === 0;
        var shouldBeRendered = alwaysRenderAll || isActive;
        return shouldBeRendered ? React.createElement("div", _extends({}, s('tab', {
          tabHidden: !isActive
        }), {
          key: name,
          role: "tabpanel",
          "aria-hidden": false
        }), React.createElement(Tab, {
          index: index
        })) : null;
      });

      var info = {
        tabs: tabs,
        prevIndex: this.prevIndex
      };
      return React.createElement("div", _extends({}, s.with('container')(this.props), rest), React.createElement(TabBar, {
        activeTab: activeTab,
        onChange: onChange,
        items: items
      }), React.createElement("div", s('tabs'), children ? children(info) : tabs));
    }
  }]);

  return Tabs;
}(PureComponent), _defineProperty(_class2, "displayName", 'Tabs'), _defineProperty(_class2, "propTypes", {
  children: types.func,
  items: types.arrayOf(types.shape({
    label: types.oneOfType([types.string, types.node]).isRequired,
    name: types.string.isRequired,
    Tab: types.elementType
  })).isRequired,
  activeTab: types.string,
  onChange: types.func,
  TabBar: types.elementType,
  alwaysRenderAll: types.bool
}), _defineProperty(_class2, "defaultProps", {
  TabBar: TabBarDefault
}), _temp)) || _class);
export default Tabs;